module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e1675"
    }
  }, [_c('span', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e1725"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Bres_9781595554123_epub_c5_r1#d7e1",
      "id": "d6e1"
    }
  }, [_c('i', [_vm._v("A Note from the Editor")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e1755"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Bres_9781595554123_epub_c6_r1#d7e2",
      "id": "d6e2"
    }
  }, [_c('i', [_vm._v("Introduction")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e1785"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Bres_9781595554123_epub_c7_r1#d7e3",
      "id": "d6e3"
    }
  }, [_vm._v("Chapter One: Named for a Warrior")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e1815"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Bres_9781595554123_epub_c9_r1#d7e4",
      "id": "d6e4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Two: At Home at West Point")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e1845"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Bres_9781595554123_epub_c10_r1#d7e5",
      "id": "d6e5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three: The Enchanting South")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e1875"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Bres_9781595554123_epub_c11_r1#d7e6",
      "id": "d6e6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four: California Interlude")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e1915"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Bres_9781595554123_epub_c12_r1#d7e7",
      "id": "d6e7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five: Captain and Married Man")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e1945"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Bres_9781595554123_epub_c14_r1#d7e8",
      "id": "d6e8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six: The Middle Passage")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e1975"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Bres_9781595554123_epub_c15_r1#d7e9",
      "id": "d6e9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven: Superintendent")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e2005"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Bres_9781595554123_epub_c17_r1#d7e10",
      "id": "d6e10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight: The Debacle at Bull Run")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e2086"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Bres_9781595554123_epub_c18_r1#d7e11",
      "id": "d6e11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine: Lost in the Wilderness")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e2116"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Bres_9781595554123_epub_c19_r1#d7e12",
      "id": "d6e12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Ten: Redemption at Shiloh")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e2146"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Bres_9781595554123_epub_c21_r1#d7e13",
      "id": "d6e13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eleven: The Formative Interlude")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e2176"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Bres_9781595554123_epub_c23_r1#d7e14",
      "id": "d6e14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twelve: Triumph and Tragedy")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e2206"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Bres_9781595554123_epub_c25_r1#d7e15",
      "id": "d6e15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aftermath and Legacy")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2236"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Bres_9781595554123_epub_c26_r1#d7e16",
      "id": "d6e16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e223d6"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Bres_9781595554123_epub_c27_r1#d7e17",
      "id": "d6e17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2276"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Bres_9781595554123_epub_c28_r1#d7e18",
      "id": "d6e18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-688a9ca8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Bres_9781595554123_epub_c4_r1.vue
// module id = 69
// module chunks = 0